import { render, staticRenderFns } from "./team-card.vue?vue&type=template&id=d2e57088&"
import script from "./team-card.vue?vue&type=script&lang=ts&"
export * from "./team-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports